import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDataLayerValue } from '../../../DataLayer';
import { db } from '../../../firebase';
import PlayListMain from '../../Item/PlayListMain';
import PlayListTable from '../../Item/PlayListTable';
import Loading from '../Loading';


function Tracks(props) {
    const [idPlaylist] = useState('PLAYLISTMYLOVE');
    const [playListDetail, setPlayListDetail] = useState({});
    const [listSong, setListSong] = useState([]);
    const [loadingPage, setLoadingPage] = useState(true);
    const [{ playlist_song_love }, dispatch] = useDataLayerValue();
    let history = useHistory();

    useEffect(() => {
        if (idPlaylist) {
            db.collection("playlists").doc(`${idPlaylist}`)
                .get()
                .then(function (doc) {
                    setPlayListDetail({ id: doc.id, ...doc.data() });
                })
                .catch(function (error) {
                    console.log("Error getting detail playlist.");
                    history.push('/error');
                });

        }
    }, []);

    useEffect(() => {
        if (playlist_song_love.length > 0) {
            let startArr = 0;
            let endArr = 10;
            let arrIdUpdateTmp = [];
            let arrSongUpdateTmp = [];
            let arrTmp = [...playlist_song_love];
            let lengthArr = arrTmp.length;
            let totalFor = Math.ceil(lengthArr / 10);
            for (let i = 0; i < totalFor; i++) {
                let arrSlice = arrTmp.slice(startArr, endArr);
                startArr = endArr;
                endArr = endArr + 10;
                db.collection("songs").where("status", "==", true).where('key', 'in', arrSlice)
                    .get()
                    .then(function (querySnapshot) {
                        arrSongUpdateTmp = [...arrSongUpdateTmp, ...querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))]
                        arrIdUpdateTmp = [...arrIdUpdateTmp, ...querySnapshot.docs.map(doc => (doc.id))];
                        if (i === totalFor - 1) {
                            setListSong([...arrSongUpdateTmp]);
                            setLoadingPage(false);
                            dispatch({
                                type: 'SET_PLAYLISTS',
                                playlists: arrIdUpdateTmp
                            });

                        }
                    })
                    .catch(function (error) {
                        console.log("Error getting categories.");
                        history.push('/error');
                    });

            }


        } else {
            setLoadingPage(false);
        }

    }, []);



    return (
        <div className="Root__right-container__section--wrap-page ">
            <PlayListMain countSongs={listSong.length} countTimes={listSong.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.time), 0)} playListDetail={playListDetail} type="playlist" />
            <PlayListTable listSong={listSong} backgroundColor={playListDetail.bg_color ? playListDetail.bg_color : '#000'} />
            <Loading loadingPage={loadingPage} />
        </div>
    );
}

export default Tracks;